import { findGuide, GETTING_STARTED_SLUG } from '../content';

import { GuidePage } from './guide-page';
import { DocsNotFoundPage } from './not-found-page';

/** `/docs`: the getting-started guide. */
export function GettingStartedPage() {
  const guide = findGuide(GETTING_STARTED_SLUG);
  return guide ? <GuidePage guide={guide} /> : <DocsNotFoundPage />;
}
